module.exports = __webpack_public_path__ + "static/TT1335_TW-MARK-M01a-clean-f6756108217cf72df1c33f08d4da9fa1.png";